import { Context, useContext } from "react";

export const useSafeContext = <T>(
  context: Context<T | undefined>,
  contextName = "context",
) => {
  const value = useContext(context);
  if (!value) {
    throw new Error(
      `useSafeContext must be used within the ${contextName} provider`,
    );
  }
  return value;
};
